import c, { useRef as f, useEffect as m } from "react";
import i from "jsbarcode";
import s from "./barcode.module.scss.js";
function d({
  data: e,
  displayValue: t,
  width: n,
  height: o
}) {
  const r = f(null);
  return m(() => {
    r.current !== null && i(r.current).CODE128(e, {
      text: e,
      displayValue: t,
      margin: 20,
      width: n ?? 2,
      height: o ?? 100
    }).render();
  }, [e, t]), /* @__PURE__ */ c.createElement(
    "img",
    {
      "data-testid": "barcode",
      alt: "",
      ref: r,
      className: s.svg
    }
  );
}
export {
  d as Barcode
};
//# sourceMappingURL=Barcode.js.map
